import { useEffect, useState } from "react";

export function useCountdown(target, onDone) {
  const [left, setLeft] = useState("");
  useEffect(() => {
    if (!target) { setLeft(""); return; }
    const t = new Date(target).getTime();
    let done = false;
    const tick = () => {
      const diff = t - Date.now();
      if (diff <= 0) {
        setLeft("00:00:00");
        if (!done) { done = true; onDone?.(); }
        return;
      }
      const h = String(Math.floor(diff / 3600000)).padStart(2, "0");
      const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
      const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
      setLeft(`${h}:${m}:${s}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target, onDone]);
  return left;
}
